export default __webpack_public_path__ + "static/media/Logo_Pepper_Horizontal.5bcaaf6d.svg";